import { CollaborationResult, ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

// import { INFRASTRUCTURE_ERROR_IDENTIFIER } from '../interfaces/infrastructure-error';
import type { IPegasusGateway } from '../interfaces/pegasus.gateway';

@injectable()
export class GetCurrentStudentClassesCollaboration
  implements ICollaboration<string, CollaborationResult<any>>
{
  constructor(
    @inject('IPegasusStudyPlanGateway')
    private readonly pegasusIOGateway: IPegasusGateway,
  ) {}

  public async run(classifierGuid: string): Promise<CollaborationResult<any>> {
    try {
      const response = await this.pegasusIOGateway.getCurrentStudentClasses(classifierGuid);

      if (!response) {
        return null;
      }
      return response;
    } catch (e) {
      return e;
    }
  }
}
